import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/PMS/customerService/complaintManage';
import { fetchDetail as fetchUserDetail } from '@/api/system/user/user';
export default {
  props: {
    showDialog: Boolean,
    keyValue: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      rules: {
        appointmentTime: [{
          required: true,
          message: '请选择预约处理时间',
          trigger: 'change'
        }],
        contact: [{
          required: true,
          message: '请输入联系人',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入联系人电话',
          trigger: 'blur'
        }],
        eventalSite: [{
          required: true,
          message: '请输入问题发生地',
          trigger: 'blur'
        }],
        situationType: [{
          required: true,
          message: '请选择紧急情况',
          trigger: 'change'
        }],
        complaintAddress: [{
          required: true,
          message: '请输入投诉地址',
          trigger: 'blur'
        }],
        complaintContent: [{
          required: true,
          message: '请输入投诉内容',
          trigger: 'blur'
        }]
      },
      statusOption: [{
        name: '未处理',
        value: 1
      }, {
        name: '处理中',
        value: 2
      }, {
        name: '已处理',
        value: 3
      }],
      sourceOption: [// { name: '微信', value: 1 },
      {
        name: '电话',
        value: 2
      }, {
        name: '现场登记',
        value: 3
      }],
      situationOption: [{
        name: '紧急',
        value: 0
      }, {
        name: '一般',
        value: 1
      }],
      userName: '',
      uploadUrl: '',
      downloadUrl: '',
      dialogImageUrl: '',
      fileList: [],
      files: [],
      dialogVisible: false,
      complainantsPhone: '',
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.fileList = [];
      this.files = [];
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });
      fetchUserDetail({
        userId: this.$store.state.user.userId
      }).then(function (res) {
        _this.complainantsPhone = res.data.data.mobilephone;
        _this.userName = res.data.data.userName;
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
          _this.childData.fileMsgs && _this.childData.fileMsgs.forEach(function (item) {
            _this.fileList.push({
              name: item.fileName,
              url: _this.downloadUrl + item.fileId,
              fileId: item.fileId,
              fileName: item.fileName,
              fileUrl: item.fileId
            });
          });
          _this.files = _this.fileList;
        });
      } else {
        this.childData = {};
      }
    },
    handCreate: function handCreate() {
      var _this2 = this;

      if (location.hash === '#/complaintManage/newComplaint') {
        this.childData.sysType = 2;
      } else {
        this.childData.sysType = 1;
      }

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this2.childData.fileMsgs = _this2.fileList;

          if (_this2.keyValue > 0) {
            fetchUpdate(_this2.childData).then(function () {
              _this2.$emit('handCancle', true);

              _this2.Alert({
                alertType: 'update'
              });
            });
          } else {
            fetchCreate(_this2.childData).then(function () {
              _this2.$emit('handCancle', true);

              _this2.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this2.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handleSuccess: function handleSuccess(response, file) {
      this.fileList.push({
        url: this.downloadUrl + file.response.data[0].fileId,
        fileUrl: file.response.data[0].fileId,
        fileId: file.response.data[0].fileId,
        name: response.data[0].fileName,
        fileName: response.data[0].fileName,
        fileType: this.judgeFileType(file.raw.type)
      });
    },
    handleError: function handleError(err, file, fileList) {
      var res = JSON.parse(err.message);
      this.$message({
        message: res.message,
        type: 'error'
      });
    },
    handleExceed: function handleExceed() {
      this.$message({
        message: '最多只能上传1个文件!',
        type: 'warning'
      });
    },
    handlePreview: function handlePreview(file) {
      console.log('file', file);

      if (file.response !== undefined) {
        // 当还未保存到业务逻辑中时的预览图片
        if (file.raw.type === 'image/png' || file.raw.type === 'image/jpeg' || file.raw.type === 'image/jpg') {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      } else {
        // 当已保存到业务逻辑中时的预览图片
        if (file.name && (file.name.includes('jpeg') || file.name.includes('jpg') || file.name.includes('png'))) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.url;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      }
    },
    // 移除图片之前做的操作
    beforeRemove: function beforeRemove(file, fileList) {// return this.$confirm(`确定移除 ${ file.name }？`)
    },
    beforeUpload: function beforeUpload(file) {
      var extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      extension = extension.toLowerCase();
      var isLt2M = file.size / 1024 / 1024 < 10;
      var fileFormatOK = extension === 'jpg' || extension === 'jpeg' || extension === 'JPEG' || extension === 'png' || extension === 'bmp' || extension === 'gif';

      if (!fileFormatOK) {
        this.$message({
          message: '只支持上传 jpg/jpeg/png/bmp/gif 格式!',
          type: 'error'
        });
        return false;
      }

      if (!isLt2M) {
        this.$message({
          message: '上传大小不能超过 10MB!',
          type: 'error'
        });
        return false;
      }
    },
    // 移除图片
    handleRemove: function handleRemove(file) {
      var _this3 = this;

      var currentUrl = 0; // 获取当前删除文件的url

      if (file.response !== undefined) {
        // 文件是新增加的
        currentUrl = file.response.data[0].fileId;
      } else {
        // 文件是旧数据
        currentUrl = file.url;
      }

      this.fileList.forEach(function (item, index) {
        if (currentUrl === item.url) {
          _this3.fileList.splice(index, 1);

          return;
        }
      });
    },
    // 下载文件
    handleDownload: function handleDownload(url, name) {
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    },
    // 判断上传的文件类型，方便数据库保存
    judgeFileType: function judgeFileType(str) {
      if (str === 'image/png' || str === 'image/jpeg' || str === 'image/jpg') {
        return 2;
      } else {
        return 1;
      }
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};